import Minesweeper from "./Minesweeper";

export default Minesweeper;
